/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import maxBy from 'lodash.maxby';
import minBy from 'lodash.minby';

/**
 * Provides a utility to get the Maximum item based on function Provided.
 *
 * ```typescript
 *
 *   import {getMaximumBy} from '@ion/core/src/utils/';
 *
 *   getMaximumBy([{ 'n': 1 }, { 'n': 2 }], (o) => o.n) // { 'n': 2 }
 *
 * ```
 */
export const getMaximumBy = (data: any[], func: Function): any => {
  return maxBy(data, func);
};

/**
 * Provides a utility to get the Minimum item based on function Provided.
 *
 * ```typescript
 *
 *   import {getMinimumBy} from '@ion/core/src/utils/';
 *
 *   getMinimumBy([{ 'n': 1 }, { 'n': 2 }], (o) => o.n) // { 'n': 1 }
 *
 * ```
 */
export const getMinimumBy = (data: any[], func: Function): any => {
  return minBy(data, func);
};
